export const ACTIVITY_SYNC_KEY = "apit:auth:last-activity";
export const ACTIVITY_IDLE_AFTER_MS = 4 * 60 * 1000;

export function localDayKey(value = new Date()) {
	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) return "";
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}

export function startOfLocalDay(value = new Date()) {
	const date = value instanceof Date ? new Date(value) : new Date(value);
	date.setHours(0, 0, 0, 0);
	return date.getTime();
}

export function readLastActivityAt(fallback = Date.now()) {
	try {
		const stored = Number(localStorage.getItem(ACTIVITY_SYNC_KEY));
		if (Number.isFinite(stored) && stored > 0 && stored <= Date.now() + 60_000) return stored;
	} catch (_) {
		// Storage can be unavailable in privacy-restricted browser contexts.
	}
	return fallback;
}

export function writeLastActivityAt(timestamp = Date.now()) {
	try {
		localStorage.setItem(ACTIVITY_SYNC_KEY, String(timestamp));
	} catch (_) {
		// Activity tracking still works in-memory when storage is unavailable.
	}
}
